import { useInfiniteQuery, UseInfiniteQueryOptions } from '@tanstack/react-query';
import axios from 'axios';
import { BaseError } from '~/components/Error/BaseError';
import { LandType, ZoneType } from '~/components/Land/Land.hooks';

export type LandEventWinnerParams = {
  pageSize?: number;
  pageNo?: number;
};

export type LandEventWinnerRanking = {
  ranking: number;
  profileImageUrl: string;
  displayName: string;
  landType: LandType;
  zoneType: ZoneType;
  // Derived from zoneType
  zoneNumber: number;
  snapshot: {
    lup: number;
    citizenNftLevel: number;
    citizenNftCount: number;
  };
  rewardAmountInFnsa: number;
  rewardAmountInUsd: number;
};

export type LandEventWinnersResponse = {
  pageNo: number;
  isLast: boolean;
  totalCount: number;
  week: number;
  rankingList: LandEventWinnerRanking[];
};

export const landEventWinnersUrl = '/api/citizen/v1/lands/winners/ranking';

export const transformLandEventWinners = (data: LandEventWinnersResponse) => ({
  ...data,
  rankingList: data.rankingList.map((winnerRanking) => ({
    ...winnerRanking,
    zoneNumber: Number(winnerRanking.zoneType.split('_')[1]),
  })),
});
export const getLandEventWinners = async (params?: LandEventWinnerParams) => {
  const { data } = await axios.get<LandEventWinnersResponse>(landEventWinnersUrl, {
    params,
  });
  return transformLandEventWinners(data);
};
export const useLandEventWinners = (
  params?: LandEventWinnerParams,
  options?: UseInfiniteQueryOptions<LandEventWinnersResponse, BaseError>
) =>
  useInfiniteQuery({
    queryKey: ['land', 'event', 'winner', params],
    queryFn: ({ pageParam: pageNo }) => getLandEventWinners({ ...params, pageNo }),
    getNextPageParam: ({ isLast, pageNo }) => (isLast ? undefined : pageNo + 1),
    ...options,
  });
